import Joi from "joi-browser";
import { isEmpty } from "lodash";

const validate = (
    input,
    schema,
    setIsFormValid,
    setError,
    options,
    errorObject,
    joinErrorPaths = true
) => {
    try {
        const valid = Joi.validate(input, schema, {
            abortEarly: options?.abortEarly || false,
            allowUnknown: options?.allowUnknown || true,
            context: options?.context || {},
        });

        const newErrorObject = errorObject || {};

        if (valid.error) {
            valid.error.details.forEach((err) => {
                newErrorObject[
                    joinErrorPaths ? err.path.join(".") : err.path[0]
                ] = err.message;
            });
        }
        setIsFormValid(isEmpty(newErrorObject));
        setError(newErrorObject);
        return newErrorObject;
    } catch (error) {
        console.log(error);
    }
};

export { validate };
